import React from "react";

const AnalyticsMiniBarChart = ({
  values,
  labels = [],
  barColors = [],
  showAlternateLabels = false,
  showAllLabels = false,
  labelClassName = "",
  barClassName = "bg-[#5FAFE3]",
  height = 170,
}) => {
  const maxValue = Math.max(...values);

  return (
    <div className="w-full">
      <div className="flex items-end justify-center gap-3 sm:gap-4" style={{ height }}>
        {values.map((value, index) => {
          const barHeight = Math.max(18, (value / maxValue) * 100);
          const computedBarClassName = barColors[index] ?? barClassName;

          return (
            <div
              key={`${value}-${index}`}
              className={["w-5 rounded-t-sm sm:w-[22px]", computedBarClassName].join(" ")}
              style={{ height: `${barHeight}%` }}
            />
          );
        })}
      </div>

      {showAlternateLabels || showAllLabels ? (
        <div className="mt-3 flex justify-center  sm:gap-4">
          {values.map((_, index) => {
            const labelIndex = Math.floor(index / 2);
            const shouldShowAlternateLabel = index % 2 === 0;
            const labelText = showAllLabels
              ? labels[index]
              : shouldShowAlternateLabel
              ? labels[labelIndex]
              : "";

            return (
              <div
                key={`label-${index}`}
                className={[
                  " text-center text-[7px] font-['Inter'] text-[#000] font-light ",
                  labelClassName,
                ].join(" ")}
              >
                {labelText}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default AnalyticsMiniBarChart;
